import "UI/Widget/Forms/Control/Element";
NS("UI.Widget.Forms.Control");

UI.Widget.Forms.Control.EnumCheckbox = Class(UI.Widget.Forms.Control.Element, {
    createElement: function() {
        var enumClass;
        var attributes = {};
        var onClick = this.$control.attr("on-click");
        var multiline = this.$control.attr("multiline");

        if (multiline == "no") {
            multiline = false;
        }

        multiline = !!Util.coalesce(multiline, true);

        if (onClick) {
            attributes["on-click"] = onClick;
        }

        eval("enumClass = " + this.$control.attr("enum") + ";");

        this.$element = UI.Template.$render("UI/Widget/Forms/Control/EnumCheckbox/Control", {
            enum: enumClass,
            attributes: attributes,
            multiline: multiline
        });
    },

    insertElement: function() {
        var self = this;
        var isSwitch = this.$control.attr("switch") !== undefined;

        this.ParentCall();

        $("input", this.$element).on("change", function() {
            var value = [];

            if (isSwitch) {
                $("input", self.$element).not(this).prop("checked", false);
            }

            $("input", self.$element).each(function() {
                if ($(this).is(":checked")) {
                    value.push(parseInt(this.value));
                }
            });

            self.setValue(value);
        });
    },

    updateElement: function(value) {
        if (!Util.isArray(value)) {
            value = [];
        }

        $("input", this.$element).each(function() {
            var flag = !!~value.indexOf(parseInt(this.value, 10));
            $(this).attr("checked", flag).prop("checked", flag);
        });
    }
});
